<template>
  <div class="chat bg-chat">

  </div>
</template>

<script>
import { Tooltip, Button } from "ant-design-vue";

export default {
  components: {
    "a-tooltip": Tooltip,
    "a-button": Button,
  },
  data() {
    return {
      settings: {
        suppressScrollX: true,
      },
      emojGroupListVisible: false,
      chatVisible: false,
    };
  },
  methods: {
    scrollHanle(evt) {},
    toggleEmojGroupList() {
      this.emojGroupListVisible = !this.emojGroupListVisible;
    },
    showChat() {
      this.chatVisible = true;
    },
    hideChat() {
      this.chatVisible = false;
    },
  },
  mounted() {
    var userItems = document.getElementsByClassName("user-list-item");
    var leftSidebar = document.getElementsByClassName("left-sidebar")[0];
    var chat = document.getElementsByClassName("chat")[0];

    for (var i = 0; i < userItems.length; i++) {
      var userItem = userItems[i];
      if (
        !userItem.matches(":scope > body.status-page .user-list-item") &&
        !userItem.matches(":scope > body.voice-call-page .user-list-item")
      ) {
        userItem.addEventListener("click", function () {
          if (window.innerWidth < 992) {
            leftSidebar.classList.add("hide-left-sidebar");
            chat.classList.add("show-chatbar");
          }
        });
      }
    }
  },
};
</script>
